module.exports = __webpack_public_path__ + "img/truck-fast-solid.552485a3.svg";